export default function getTodayDate() {
  const today = new Date();
  today.setHours(today.getHours() - 3);
  const todayFormatted = today.toJSON().slice(0, 10);
  const currentDay = todayFormatted.split('-')[2];
  const currentMonth = todayFormatted.split('-')[1];
  const currentYear = todayFormatted.split('-')[0];
  const currentDate = `${currentDay}/${currentMonth}/${currentYear}`;

  return currentDate;
}
